import React from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY).catch(() => null)

const elementsProps = {
  fonts: [
    {
      cssSrc: 'https://fonts.googleapis.com/css?family=Nunito+Sans',
    },
  ],
}

export function StripeProvider({ children }: { children: React.ReactNode }) {
  return (
    <Elements options={elementsProps} stripe={stripePromise}>
      {children}
    </Elements>
  )
}
